
import FileList from '@/components/file_list/index.vue'
import { Component, Vue } from 'vue-property-decorator'
import { ContactService, UserService, ReporterService, MediaService } from '@/services/index'

@Component({
    name: 'ContactDetail',
    components: {
        FileList
    }
})
export default class extends Vue {
    private activeTab = 'info'
    private contactId = 0
    private reporterInput = ''
    private selectReporter: any = ''
    private mediaInput = ''
    private selectMedia: any = ''
    private replyMessage = ''
    private contact: any = {
        user: {},
        principal: {},
        memo: '',
        reporter: { media: {} },
        annexes: []
    }
    private users = []
    private statusOptions = [
        { key: 1, value: '未跟进' }, 
        { key: 2, value: '跟进中' }, 
        { key: 3, value: '跟进完成' }, 
        { key: 4, value: '无需跟进' }
    ]
    private mapCertStatus: any = {
        0: '未认证',
        1: '申请认证中',
        2: '认证成功',
        3: '认证失败'
    }
    private claimStatus = {
        0: '未认领',
        1: '已认领'
    }
    private loading = false
    private mediaList: any[] = []


    private mounted() {
        const id = this.$route.params.id
        this.contactId = parseInt(id)
        this.initData()
    }

    private matchNewsLink(media: any) {
        if (!media) return ''
        const baseLink = '/news/list?mediaId=%id&name=%name'
        return baseLink.replace('%id', media.id).replace('%name', media.name)
    }

    private async initData() {
        this.loading = true
        this.$title('Loading | 报料详情 - 庖丁')
        await Promise.all([
            this.getUsers(),
            this.getContact()
        ])
        this.loading = false
    }

    private async getUsers() {
        const result = await UserService.getUsers({ page_index: 1, page_size: 100 })
        if (result.status === 200) {
            this.users = result.data.users
        }
    }

    private async getContact() {
        const result = await ContactService.getContact({ id: this.contactId })
        if (result.status === 200) {
            const { title } = result.data
            this.$title(`${title} | 报料详情 - 庖丁`)
            this.contact = result.data
        }
    }

    private async updateContact(data: any) {
        const params = Object.assign({ id: this.contactId }, data)
        const result = await ContactService.updateContact(params)
        if (result.status === 200) {
            this.$message({ type: 'success', message: '设置成功' })
            return true
        }
        this.$message.error(result.message || '设置失败')
        return false
    }

    private async getReporters(name: string) {
        const params = { keyword: name, page_index: 1, page_size: 10 }
        const result = await ReporterService.search(params)
        if (result.status === 200) {
            return result.data.results || []
        }
        return []
    }

    private async getMedias(name: string) {
        const params = { value: name, page_index: 1, page_size: 10 }
        const result = await MediaService.searchMedia(params)
        if (result.status === 200) {
            return result.data || []
        }
        return []
    }


    private async onStatusSelect(status: any) {
        const result = await this.updateContact({ status: status })
        if (result) {
            this.contact.status = status
        }
    }

    private async onUserSelect(userId: string) {
        const result = await this.updateContact({ principal: userId })
        if (result) {
            this.contact.principal.id = userId
        }
    }

    private onMemoBlur() {
        this.updateContact({ memo: this.contact.memo })
    }

    private async itemSearch(queryString: string, cb: Function, type: 'media'| 'reporter') {
        if (type === 'reporter') {
            const reporters = await this.getReporters(queryString)
            cb(reporters)
        } else {
            const medias = await this.getMedias(queryString)
            cb(medias)
        }
    }

    private onItemSelect(item: any, type: 'media'| 'reporter') {
        if (type === 'reporter') {
            this.reporterInput = item.name
            this.selectReporter = item
        } else {
            const isExist = this.mediaList.findIndex(media => media.id === item.id) !== -1
            if (isExist) {
                this.$message({
                    type: 'warning',
                    message: '该媒体已被选择',
                    showClose: true
                })
                return
            }
            this.mediaList.push(item)
        }
    }

    private onPush(type: 'media' | 'reporter') {
        let mediaIds: any = []
        let reporterId: any = ''
        if (type === 'reporter') {
            if (!this.selectReporter.id) {
                return this.$message.warning('请选择记者')
            } else if (this.selectReporter.name !== this.reporterInput) {
                return this.$message.warning('请正确选择记者')
            }
            mediaIds = undefined
            reporterId = this.selectReporter.id
        } else {
            if (!this.mediaList.length) {
                return this.$message.warning('请选择媒体')
            }
            reporterId = undefined
            mediaIds = this.mediaList.map(media => media.id)
        }
        
        const strTemplate = '确定要将该主题推送给$t'
        let message = ''
        if (type === 'reporter') {
            message = strTemplate.replace('$t', `${this.reporterInput}记者吗?`)
        } else {
            message = strTemplate.replace('$t', '如下媒体吗?')
        }
        
        this.$confirm(message, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(async () => {

            const params = {
                media_ids: mediaIds,
                reporter_id: reporterId
            }

            const result = await this.redirectAudit(params)
            if (result.status) return this.$message.success('推送成功')
            throw new Error(result.message)
        }).catch(err => {
            this.$message.error(err.message)
        })
    }

    private async redirectAudit(params: any) {
        params = {
            ...params,
            contact_id: String(this.contactId)
        }
        const { status, message } = await ContactService.pushToReporter(params)
        if (status === 200) {
            return { status: true }
        }
        return { status: false, message }
    }

    // 删除已选中的媒体
    private onMediaClose(media: any) {
        this.mediaList.splice(this.mediaList.indexOf(media), 1)
    }

    private onSelectMsg(data: any) {
        this.replyMessage = data
    }

    private async onSendMessage() {
        const result = await ContactService.sendMessageToUser({ id: this.contact.id, content: this.replyMessage })
        if (result.status === 200) {
            this.$message.success('发送成功')
            this.replyMessage = ''
        }
    }
}
